export default "__VITE_ASSET__0B5hsqfP__"